module.exports = "../../app/cells/pages/question/question_suggestion_cell.rb";